export const getDomain = () => {
  const domain = window.location.origin;
  if (domain.includes('forbes.cz')) {
    return 'Secure;domain=.forbes.cz;';
  } else if (domain.includes('forbes.sk')) {
    return 'Secure;domain=.forbes.sk;';
  } else if (domain.includes('forbes.hu')) {
    return 'Secure;domain=.forbes.hu;';
  } else {
    return '';
  }
};
